import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconFlatmx from '../build/icon-flatmx'

export const IconFlatmx: React.FC<Omit<SvgProps, 'src'>> = (props) => {
  return <Svg {...props} src={iconFlatmx} />
}

export default IconFlatmx
